import React, {useEffect, useState} from "react";
import MarkdownViewer from "./MarkdownViewer";

const ExtractResults = ({documentId, extractData, splitIdPath, markdowns, splitterData}) => {
    const [markdown, setMarkdown] = useState('')
    useEffect(() => {
        if (markdowns[documentId] && splitterData[documentId]) {
            const pages = splitterData[documentId][splitIdPath]?.traddocs_watermark_indices
            const parts = markdowns[documentId].split(/<!-- PageFooter=\{traddocs_watermark_index: \d+} -->/)
            let currentMarkdown = ''
            for (let i = 0; i < pages.length; i++) {
                currentMarkdown = `${currentMarkdown}${parts[pages[i] - 1].trim()}\n[Page: ${pages[i]}]\n`
            }
            setMarkdown(currentMarkdown.trim())
        }
    }, [markdowns, documentId, splitIdPath, splitterData])

    return (
        <div className="relative flex w-full">
            <div className="w-full pb-4 bg-gray-100">
                <div className="space-y-1 w-full rounded-lg overflow-hidden px-2">
                    <MarkdownViewer markdown={markdown}/>
                </div>
            </div>
        </div>
    );
};

export default ExtractResults;
